import { UserAuthorizationGuard } from '@modules/auth/authentication-guard';
import { UserType } from '@shared/enums/user-type';
import { NoAuthGuard } from './no-auth.guard';

export const authRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: 'callback',
        loadComponent: () =>
          import('@modules/auth/auth-callback/auth-callback').then((c) => c.AuthCallback),
      },
      {
        path: 'verify-email',
        loadComponent: () =>
          import('@modules/auth/email-verification/email-verification').then(
            (c) => c.EmailVerification,
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('@modules/auth/reset-password/reset-password').then((c) => c.ResetPassword),
      },
    ],
  },
  {
    path: 'register',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('@modules/auth/register/register.component').then((c) => c.RegisterComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('@modules/auth/forgot-password/forgot-password').then((c) => c.ForgotPassword),
  },
  {
    path: 'reset-password-selection',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('@modules/auth/password-option-selection/password-option-selection').then(
        (c) => c.PasswordOptionSelection,
      ),
  },
  {
    path: 'account-verification',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('@modules/auth/account-verification/account-verification').then(
        (c) => c.AccountVerification,
      ),
  },
  {
    path: 'user-profile',
    canActivate: [UserAuthorizationGuard],
    data: { allowedUserTypes: [UserType.EXTERNAL_USER] },
    loadComponent: () =>
      import('@modules/auth/user-profile-component/user-profile-component').then((c) => c.UserProfileComponent),
  },
];
